import { createApi } from '@reduxjs/toolkit/query/react'
import { axiosBaseQuery } from '../axiosBaseQuery'
import { TicketHebType } from '../../models/types'
import { Account } from '../../models/account'


export const accountsApi = createApi({
  reducerPath: 'accountsApi',
  baseQuery: axiosBaseQuery({ baseUrl: '/api/' }),
  tagTypes: [
    'accounts',
  ],
  endpoints: (b) => ({
    

    // ---------- GET ----------

    getAccountsByType: b.query<Account[], TicketHebType>({
      query: (accountHebType) => ({ 
        url: 'accounts/search/0/id/asc?load=customData,entries.document.documentSettings',
        method: 'POST',
        data: {"account_type": accountHebType}
      }),
      providesTags: (_res, _err, accountHebType) => [
        { type: 'accounts', id: accountHebType },
      ],
      keepUnusedDataFor: Infinity,
    }),

    
    // // ---------- PATCH ----------

    // editAccount: b.mutation<Account, Account>({
    //   query: (accountStructureToUpdate) => ({
    //     url: `accounts-structure/${accountStructureToUpdate.id}`,
    //     method: 'PATCH',
    //     data: accountStructureToUpdate,
    //   }),
    //   async onQueryStarted(accountStructureToUpdate, { dispatch, queryFulfilled }) {
    //     const patch = dispatch(
    //       accountsStructureApi.util.updateQueryData('getAccountStructure', accountStructureToUpdate.account_type, draft => {
    //         const row = draft.find(t => t.id === accountStructureToUpdate.id)
    //         if (row) Object.assign(row, accountStructureToUpdate)
    //       })
    //     )
    //     try { await queryFulfilled } catch { patch.undo() }
    //   },
    //   invalidatesTags: (_res, _err, accountType) => [
    //     { type: 'accountsStructure', id: accountType.id },
    //   ],
    // }),


    // // ---------- POST ----------
    
    // addCustomAccountStructure: b.mutation<AccountStructure, AccountStructureForm>({
    //   query: (customAccountStructure) => ({
    //     url: `accounts-structure`,
    //     method: 'POST',
    //     data: customAccountStructure,
    //   }),
    //   async onQueryStarted(customAccountStructure, { dispatch, queryFulfilled }) {
    //     const temp: AccountStructure = {
    //       ...customAccountStructure, 
    //       id: 99999, 
    //       business_id: 99999, 
    //       created_at: "", 
    //       updated_at: "", 
    //       field_table: customAccountStructure.field_table ?? null,
    //       custom_field: customAccountStructure.custom_field ?? null,
    //       location: customAccountStructure.location ?? null,
    //     }
    //     const patch = dispatch(
    //       accountsStructureApi.util.updateQueryData('getAccountStructure', customAccountStructure.account_type, draft => {
    //         draft.push(temp)
    //       })
    //     )
    //     try {
    //       const { data: created } = await queryFulfilled
    //       dispatch(
    //         accountsStructureApi.util.updateQueryData('getAccountStructure', customAccountStructure.account_type, draft => {
    //           const i = draft.findIndex(x => x.id === temp.id)
    //           if (i >= 0) draft[i] = created
    //         })
    //       )
    //     } catch {
    //       patch.undo()
    //     }
    //   },
    //   invalidatesTags: (_res, _err, { account_type }) => [
    //     { type: 'accountsStructure', id: account_type},
    //   ],
    // }),

  }),
})

export const {
  useGetAccountsByTypeQuery,
  useLazyGetAccountsByTypeQuery
} = accountsApi


/**
 * @returns incomes accounts
 */
export const useGetIncomesAccountsQuery = () =>
  accountsApi.useGetAccountsByTypeQuery("הכנסה");

/**
 * @returns outcomts accounts
 */
export const useGetOutcomesAccountsQuery = () =>
  accountsApi.useGetAccountsByTypeQuery("הוצאה");

/**
 * @returns banks accounts
 */
export const useGetBanksAccountsQuery = () =>
  accountsApi.useGetAccountsByTypeQuery("בנק");

/**
 * @returns cash-boxes accounts
 */
export const useGetCashBoxesAccountsQuery = () =>
  accountsApi.useGetAccountsByTypeQuery("קופה");

/**
 * @returns system accounts
 */
export const useGetSystemAccountsQuery = () =>
  accountsApi.useGetAccountsByTypeQuery("מערכת");